<template>
 
  <v-footer color="primary" 
  class="text-center"
  padless v-if="$vuetify.breakpoint.smAndDown">
<v-bottom-navigation class="elevation-1" dark background-color="primary">
      <v-menu top :offset-y="offset" rounded="b-xl">
        <template v-slot:activator="{ on, attrs }">
          <v-btn value="recent" v-bind="attrs" v-on="on">
            <span>PRODUCTOS</span>

            <v-icon>mdi-hexagon-outline mdi-rotate-90 </v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in categorias"
            :key="index"
            :to="`/subcategoria/${item.CodigoDiv}/${item.CodigoDep}/${item.Categoria}`"
            @click="idSubCat(item.CodigoDiv, item.CodigoDep, item.Categoria)"
          >
            <v-list-item-title class="primary--text">{{
              item.Nombre
            }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-btn value="favorites" to="/" @click="toTopGo()">
        <span>INICIO</span>

        <v-icon>mdi-home</v-icon>
      </v-btn>

    </v-bottom-navigation>
    <div class="py-1 primary white--text mx-auto">
      Todos los Derechos Reservados &copy; {{ new Date().getFullYear() }} GRUPO
      DOMOSA
    </div>
  </v-footer>

</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  methods: {
    ...mapActions(["consolidadoSCategoria"]),
    ...mapMutations([
      "CLR_DATOS_SUBCAT",
      "CLR_BUSCARMARCA",
      "CLR_BUSCAREPUESTO",
      "GET_BUSCARCAT",
      "CLR_BUSCARSCAT",
      "CLR_BUSCARPROMO",
      "CLR_ERROR_AXIOS",
      "set_varCategorias",
      "CLR_DATOS_SUBCATB",
      "set_changeSubcatF",
      "CLR_DATOS_ART",
      "set_AdPromoF",
    ]),
        toTopGo() {
      window.scrollTo(0, 0);
      this.set_AdPromoF();
      this.CLR_BUSCAREPUESTO();
    },
    idSubCat(Div, Dep, Cat) {
      this.CLR_DATOS_SUBCAT();
      this.CLR_BUSCARPROMO();
      this.CLR_BUSCARSCAT();
      this.CLR_BUSCARMARCA();
      this.CLR_BUSCAREPUESTO();
      this.GET_BUSCARCAT(Cat);
      window.scrollTo(0, 0);
      this.CLR_ERROR_AXIOS();
      this.CLR_DATOS_SUBCATB();

      this.set_changeSubcatF();
      this.CLR_DATOS_ART();
      // this.CLR_PROMO();
      this.set_AdPromoF();
      this.set_varCategorias([Div, Dep, Cat]);
      if (!this.$route.params.codart) this.consolidadoSCategoria();

    },
  },
  computed: {
    ...mapState(["mnuCategorias", "maestro"]),
    categorias() {
      let xData = [];
      if (Object.entries(this.maestro).length !== 0) {
        let { ttCategoria: ttCategoria } = this.maestro;
        xData = ttCategoria;
      }
      return xData;
    },
  },
  data() {
    return {
      itemsRecursos: [
        { title: "CENTROS DE SERVICIO", link: "centroservicio" },
        { title: "DESCARGAS", link: "descargas" },
        {
          title: "CORREO DOMODECO",
          target: "_blank",
          vinculo: "https://mail.domosa.com:2096",
        },
      ],
      offset: true,
    };
  },
};
</script>

<style></style>
